import { ReactComponent as OutOfMemorySVG } from '../../assets/images/out-of-memory-icon.svg';
import { DsButton } from '../ds';
import useUpgrade from '../../hooks/useUpgrade';
import CustomerErrorMessage from './CustomErrorMessage';

/**
 * The build ran out of memory, and the way to a plan with more of it.
 *
 * The button opens the Plan section rather than buying in place (`pick`): the
 * cheapest paid plan is what an in-place Upgrade chooses, and an app that just
 * outgrew its memory needs to see the sizes. It used to be a link to the
 * pricing site, in another tab, through the legacy checkout.
 */
const OutOfMemoryError = ({ appId }: { appId: string }) => {
  const upgrade = useUpgrade(appId, { pick: true, source: 'out_of_memory' });

  return (
    <CustomerErrorMessage type='error' icon={<OutOfMemorySVG width="27px" height="26px" className='text-error-red flex-none' />} headerText="Out of Memory" description={
      <>
        <div className="text-sm font-bold">Container Memory Limit Exceeded!</div>
        <div className="text-sm mb-6">Insufficient memory has caused your project build to fail. To resolve this issue, consider upgrading to a larger container with increased memory capacity for successful builds and optimal performance.</div>
        <DsButton variant="primary" onClick={upgrade}>Upgrade Now</DsButton>
      </>
    } />
  )
}

export default OutOfMemoryError